import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/invoices")({
  staticData: { title: "Invoices" },
  component: () => <Outlet />,
})
